import type { CablesQueryVariables, Cables_Bool_Exp } from "gql/api";
import { Order_By } from "gql/api";

export function restoreCables(arr: Array<string>): Cables_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function deleteCables(arr: Array<string>): Cables_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export const defaultCableVars: CablesQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { family: Order_By.Asc }
  ]
};

export const adminCableVars: CablesQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { family: Order_By.Asc }
  ]
};

export const kocCableVars: CablesQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { family: Order_By.Asc }
  ],
  where: {
    _or: [
      { include_koc_timestamp: { _is_null: false } },
      { only_koc_timestamp: { _is_null: false } }
    ]
  }
};

export const ecopetrolCableVars: CablesQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { family: Order_By.Asc }
  ],
  where: {
    _or: [
      { include_ecopetrol_timestamp: { _is_null: false } },
      { only_ecopetrol_timestamp: { _is_null: false } }
    ]
  }
};
